import { axios } from 'src/lib';
import { RESET_NOTIFICATIONS } from 'src/constants';

// eslint-disable-next-line import/prefer-default-export
export function resetUnreadNotifications() {
  return axios
    .patch(`${RESET_NOTIFICATIONS}`)
    .then((response: { data: any }) => response.data);
}
